import { RETURN_PICKUP, buildTrackingEvents } from '@/utilities/trackingEvents';

/**
 * Per-item timeline rows for the two bulk actions in MyOrders — extracted so they can be unit-tested
 * without mounting the OMS table, same as RouteDetails/completeStopHelpers.js. One click here can move
 * every item on dozens of orders, so these are web's highest-volume producers of tracking_events.
 *
 * `eventTime` defaults once per call, not per order, so a whole bulk action shares one timestamp.
 */

// Mid-pickup orders are not in the warehouse yet, so "mark received" does not apply to them.
const isMidPickup = (order) => (order?.wh_events || []).some((event) => event?.action === 'START:PICKING_UP');

/** ITEM_RECEIVED_INTO_WAREHOUSE. No return swap — a return is received just like a forward item. */
export const buildBulkReceiveTrackingEvents = ({ orders, eventTime = new Date().toISOString() } = {}) =>
    (orders || []).flatMap((order) => {
        if (!order || isMidPickup(order)) {
            return [];
        }

        return buildTrackingEvents({
            items: order.itemsByOrderId || [],
            eventType: 'ITEM_RECEIVED_INTO_WAREHOUSE',
            eventTime,
            skipExisting: true,
        });
    });

/**
 * ITEM_DELIVERED. Returns invert — an item coming back from a consignee was collected there.
 *
 * Expects `orders` already filtered to those actually being completed; the caller needs that list for
 * the order_id update anyway.
 */
export const buildBulkCompletionTrackingEvents = ({ orders, eventTime = new Date().toISOString() } = {}) =>
    (orders || []).flatMap((order) =>
        buildTrackingEvents({
            items: order?.itemsByOrderId || [],
            eventType: 'ITEM_DELIVERED',
            returnEventType: RETURN_PICKUP,
            eventTime,
            skipExisting: true,
        })
    );
